import { createFileRoute } from "@tanstack/react-router"
import { Pencil } from "lucide-react"

import { ScheduleDefinitionForm } from "@/components/guild-events-admin/schedule-definition-form"
import { PageIntroSplitHeader } from "@/components/layout/page-intro-split-header"
import { SectionKicker } from "@/components/shared/section-kicker"
import { Card } from "@/components/ui/card"

export const Route = createFileRoute(
  "/_authed/_admin/guild-events/schedules/$scheduleId",
)({
  component: GuildEventScheduleEditRoute,
})

function GuildEventScheduleEditRoute() {
  const { scheduleId } = Route.useParams()

  return (
    <div className="grid gap-4 md:gap-5">
      <Card className="page-intro border-primary/10">
        <PageIntroSplitHeader
          kicker={<SectionKicker icon={<Pencil />}>Guild events</SectionKicker>}
          title="Edit recurring schedule"
          description="Update the event template, its recurring times, or its delivery destination."
        />
      </Card>
      <ScheduleDefinitionForm scheduleId={scheduleId} />
    </div>
  )
}
